export const CardLabels = ({ card }) => {
    return (
        <div className="boardList__card-labels">
            {card?.labels?.map((el) => (
                <div
                    key={el.id}
                    className="boardList__card-label"
                    style={{ backgroundColor: el.color }}
                />
            ))}
        </div>
    );
};